export function toast(message, type = 'info', duration = 3500) {
  const container = document.getElementById('toast-container');
  const el = document.createElement('div');
  el.className = `toast toast-${type}`;
  el.textContent = message;
  container.appendChild(el);
  requestAnimationFrame(() => el.classList.add('show'));
  setTimeout(() => {
    el.classList.remove('show');
    setTimeout(() => el.remove(), 300);
  }, duration);
}

export const ok = (m) => toast(m, 'success');
export const err = (m) => toast(m, 'error', 5000);
export const info = (m) => toast(m, 'info');

export async function confirm(message) {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal">
        <p>${message}</p>
        <div class="modal-actions">
          <button class="btn btn-ghost" data-action="cancel">Hủy</button>
          <button class="btn btn-primary" data-action="ok">Xác nhận</button>
        </div>
      </div>`;
    overlay.addEventListener('click', (e) => {
      const action = e.target.dataset.action;
      if (action === 'ok') { overlay.remove(); resolve(true); }
      else if (action === 'cancel' || e.target === overlay) { overlay.remove(); resolve(false); }
    });
    document.body.appendChild(overlay);
  });
}

export async function prompt(message, defaultValue = '') {
  return new Promise((resolve) => {
    const overlay = document.createElement('div');
    overlay.className = 'modal-overlay';
    overlay.innerHTML = `
      <div class="modal">
        <p>${message}</p>
        <textarea class="modal-input" rows="3">${defaultValue}</textarea>
        <div class="modal-actions">
          <button class="btn btn-ghost" data-action="cancel">Hủy</button>
          <button class="btn btn-primary" data-action="ok">OK</button>
        </div>
      </div>`;
    const textarea = overlay.querySelector('.modal-input');
    setTimeout(() => textarea.focus(), 50);
    overlay.addEventListener('click', (e) => {
      const action = e.target.dataset.action;
      if (action === 'ok') { const v = textarea.value; overlay.remove(); resolve(v); }
      else if (action === 'cancel' || e.target === overlay) { overlay.remove(); resolve(null); }
    });
    document.body.appendChild(overlay);
  });
}
